import {
  KEY_LEVER_LINK_URLS,
  KEY_LEVER_UNLOCKS,
  KEY_LEVERS,
  keyLeversStrings,
  type KeyLever,
  type KeyLeverGradeKey,
  type KeyLeverPriority,
} from './keyLevers.content';

export type KeyLeverSection = Readonly<{
  key: string;
  title: string;
  levers: readonly KeyLever[];
}>;

export type KeyLeverLink = Readonly<{ label: string; url?: string }>;

export const leverLinksFor = ({ links }: KeyLever): readonly KeyLeverLink[] => {
  const labels = [links.guide, links.competency, ...(links.tools ?? [])].filter(
    (label): label is string => !!label,
  );
  const leverLinks: KeyLeverLink[] = labels.map((label) => ({
    label,
    url: KEY_LEVER_LINK_URLS[label],
  }));

  if (links.other) leverLinks.push({ label: keyLeversStrings.otherLink, url: links.other });

  return leverLinks;
};

export const leverCountForPriority = (grade: KeyLeverGradeKey, priority: KeyLeverPriority) =>
  KEY_LEVERS.filter((lever) => lever.priority[grade] === priority).length;

export const leverSectionsFor = (
  grade: KeyLeverGradeKey,
  priority: KeyLeverPriority,
): readonly KeyLeverSection[] =>
  KEY_LEVER_UNLOCKS.map((unlock) => ({
    key: unlock.key,
    title: unlock.title,
    levers: KEY_LEVERS.filter(
      (lever) => lever.unlock === unlock.key && lever.priority[grade] === priority,
    ),
  })).filter((section) => section.levers.length > 0);

export const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

export const toKebabId = (value: string) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
